export const environment = {
  production: true,
  apiUrl: require('../../scripts/environments.js').apiUrlProd,
  appVersion: require('../../package.json').version,
  firebaseConfig: {

  }
};
